import React from "react"
import Helmet from "react-helmet"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

const AdvertisingMaterials = ({ location }) => (
  <Layout>
    <Helmet>
      <script
        src="https://kit.fontawesome.com/0842dd585c.js"
        crossorigin="anonymous"
      ></script>
    </Helmet>
    <SEO title="Materiały Reklamowe" />
    <div className="container">
      <div className="main">
        <ol>
          <li><Link to="/">Strona główna</Link> / <Link to="/advertising-materials">Materiały Reklamowe</Link></li>
        </ol>
        <h1>Materiały Reklamowe:</h1>
        <hr></hr>
        <div className="row">
          <div className="col-md-4">
            <a href="https://partnerzy.fototransfer.pl/assets/images/plakat_eco.jpg" download="plakat_eco.jpg">
              <div className="box__download">
                <h4><i class="far fa-images"></i> Plakat ECO</h4>
              </div>
            </a>
          </div>
          <div className="col-md-4">
            <a href="https://partnerzy.fototransfer.pl/assets/images/plakat_wedding.jpg" download="plakat_wedding.jpg">
              <div className="box__download">
                <h4><i class="far fa-images"></i> Plakat Wedding</h4>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    {/* <Link to="/">Go back to the homepage</Link> */}
  </Layout>
)

export default AdvertisingMaterials
